export class GetSaasFeatures {
    static readonly type = '[SaasFeatures] GetSaasFeatures';
}

export class ClearSaasFeaturesStore {
    static readonly type = '[SaasFeatures] ClearSaasFeaturesStore';
}
